import axios, { AxiosInstance } from "axios";
import { APP_PATH } from "../AppConstants";
import { successResponseInterceptor, errorResponseInterceptor } from "../infrastructure/global";

class ApiClient {
    instance: AxiosInstance;
    
    //private constructor() { } tsc!!!
    constructor() {
        this.instance = axios.create({
            baseURL: APP_PATH,
            method: 'post'
        });

        this.instance.interceptors.response.use(
            successResponseInterceptor,
            errorResponseInterceptor
        );
    }
}

export const apiClient = new ApiClient();